<!--
 * @Author: your name
 * @Date: 2021-05-25 15:40:18
 * @LastEditTime: 2021-05-26 09:43:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\views\Information\informationDetail.vue
-->

<template>
  <div class="page-informationDetail">
    <Header  path='/information'></Header>
    <div class="informationDetail-banner"></div>
    <div class="informationDetail-describe">
      <div class="informationDetail-center" >
        
        <span v-if="newId==1"><new1/></span>
        <span v-if="newId==2"><new2/></span>
        <span v-if="newId==3"><new3/></span>
        <span v-if="newId==4"><new4/></span>

      </div>
    </div>
    
    <Footer></Footer>
  </div>

</template>
<script>
  import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import new1 from '@/components/newfile/new1.vue'
  import new2 from '@/components/newfile/new2.vue'
  import new3 from '@/components/newfile/new3.vue'
  import new4 from '@/components/newfile/new4.vue'
  import router from '@/router'
  import cont from './cont'
  import { MessageBox as MessageBoxPC} from 'element-ui';
  export default {
    components: {
      Header,
      Footer,
      new1,
      new2,
      new3,
      new4
    },
    data() {
      return {
          newId:0
      }
    },
    created(){
        // console.log('this.router==',this.$route)
        this.newId=this.$route.params.id
    },
    methods:{




      /**
       * 点击跳转
      */
      jump (value) {
            // console.log('value========',value)
        router.push({
            path: value,
          }).catch(err => {
            console.log(err)
          })
        
      },
      open() {
        MessageBoxPC.alert('023-68663505', '电话咨询', {
          confirmButtonText: '确定',
          
        }).catch((err)=>{
          console.log(err);
        });
      },


    }
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>

